import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import './NotificationPanel.css';

export default function NotificationPanel({ isOpen, onClose, notifications = [] }) {
    const panelRef = useRef(null);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (panelRef.current && !panelRef.current.contains(event.target)) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onClose]);

    return ReactDOM.createPortal(
        <div ref={panelRef} className={`notification-panel left-slide ${isOpen ? 'open' : ''}`}>
            <button className="notification-panel-close-btn" onClick={onClose}>
                <i className='fi fi-rr-cross'></i>
            </button>
            <h3 className="notification-panel-panel-title">Notifications</h3>
            {notifications?.length > 0 ? (
                notifications?.map((note, i) => (
                    <div key={i} className="notification-panel-notification-item">
                        <img src={note.img} onError={(e) => (e.target.src = 'https://via.placeholder.com/50')} alt="thumb" className="notification-thumbnail" />
                        <div className="notification-content">
                            <strong>{note?.title }</strong>
                            <p>{note?.body}</p>
                        </div>
                    </div>
                ))
            ) : (
                <p className="notification-panel-empty-message">No new notifications</p>
            )}
        </div>,
        document.body
    );
}
